import { redirectToHome, redirectToChatHistory } from '@/utils/common';
import { errorCodes } from '@/utils/constants';
import { isBrowserSupported } from '@/utils/common';
import bizTransport from '@/modules/bizTransport';
import logger from '@/modules/Logger';
import store from '@/store/index';
import { Loading } from 'element-ui';

const verifyTestLessonToken = async (to, from, next) => {
  const isStudent = to.params.isStudent;
  const lessonId = to.params.lessonId;
  const partnerId = to.params.partnerId;
  const webrtcId = to.params.webrtcId;
  try {
    await store.dispatch('getTestLessonInfo', { isStudent, lessonId, partnerId, webrtcId });
    next();
  } catch (error) {
    logger.error('Error getting test lesson token' + error,{
      event_type:37,
      operation:'verify-test-lesson-token',
      lesson_id:lessonId
    });
    next({ path: `error` });
  }
};

const verifyLessonToken = async (to, from, next) => {
  const lessonId = to.params.lessonId;
  const legacy = to.query.legacy;
  await store.dispatch('setLegacy', { legacy:legacy });
  logger.info('[MyStage API] Legacy flag for MyStage API: ' + (legacy ? 'true' : 'false'), {
    operation: 'lesson:legacy-info',
    event_type: 38,
    lesson_id: lessonId,
    legacy: legacy
  });

  await store.dispatch('checkApiMigrationCanaryUser', { lessonId, legacy });

  try {
    const lis = await store.dispatch('getLessonInfo', { lessonId, legacy });
    if (!lis) {
      checkBrowser(to, from, next);
    } else {
      const consolebizTransport = new bizTransport(store.getters.logTransportToken);
      logger.add(consolebizTransport);
      logger.error('Error getting lesson info: ' + lis, {
        operation: 'lesson:get-info',
        event_type: 38,
        lesson_id: lessonId
      });
      logger.remove(consolebizTransport);
      if (
        lis.hasOwnProperty('response') &&
        lis.response.hasOwnProperty('status') &&
        lis.response.hasOwnProperty('data') &&
        lis.response.data.hasOwnProperty('a')
      ) {
        if (lis.response.status === 422) {
          redirectToChatHistory(lis.response.data.a, lessonId);
        } else {
          redirectToHome(errorCodes.ME003, lessonId);
        }
      } else {
        redirectToHome(errorCodes.ME003, lessonId);
      }
    }
  } catch (error) {
    logger.error('Error getting lesson token: ' + error, {
      event_type: 39, 
      lesson_id: lessonId
    });
    redirectToHome(errorCodes.ME004, lessonId);
  }
};

const verifyAdminTrainerLessonToken = async (to, from, next) => {
  const lessonId = to.params.lessonId;
  try {
    await store.dispatch('getAdminTrainerLessonInfo', { lessonId });
    checkBrowser(to, from, next);
  } catch (error) {
    logger.error('Error getting lesson token: ' + error,{
      event_type: 39,
      operation: 'verify-admin-trainer-lesson-info',
      lesson_id: lessonId
    });
    redirectToHome(errorCodes.ME004);
  }
};

const verifyAccessToMaterial = async (to, from, next) => {
  try {
    const trainerHtmlPerLesson = to.params.userTypeMaterial === 'trainer';
    const params = [
      {
        p: to.params.programId,
        l: to.params.lessonId,
        r: to.params.rankId,
        rv: to.params.revamp,
        hv: 1,
        tl: trainerHtmlPerLesson
      },
      [
        {
          p: to.params.programId,
          l: to.params.lessonId,
          r: to.params.rankId,
          rv: to.params.revamp,
          hv: 1
        },
        'lessonmaterials/html.json',
      ]
    ];
    let loadingInstance = Loading.service();
    await store.dispatch('htmlMaterial/getUserToken');

    trainerHtmlPerLesson
      ? await store.dispatch('htmlMaterial/getHtmlTrainerMaterials', params[0])
      : await store.dispatch('htmlMaterial/getHtmlMaterial', params[1]);

    loadingInstance.close();
    next();
  } catch (error) {
    logger.error('Error getting user token: ' + error,{
      event_type:40,
      operation:'verify-access-material',
      program_id:to.params.programId,
      lesson_id:to.params.lessonId,
      rank_id:to.params.rankId
    });
    redirectToHome(errorCodes.ME004);
  }
};

const verifyAccessToTrainerMaterial = async (to, from, next) => {
  try {
    const params = {
      p: to.params.programId,
      r: to.params.rankId
    };
    let loadingInstance = Loading.service();
    await store.dispatch('htmlMaterial/getUserToken');
    await store.dispatch('htmlMaterial/getHtmlTrainerMaterials', params);
    setTimeout(() => loadingInstance.close(), 500);
    next();
  } catch (error) {
    logger.error('Error getting user token: ' + error,{
      event_type:40,
      operation:'verify-access-trainer-html-material',
      program_id:to.params.programId,
      rank_id:to.params.rankId
    });
    redirectToHome(errorCodes.ME004);
  }
};

const checkBrowser = (to, from, next) => {
  if (to.name === 'BrowserNotSupported') {
    // redirect to error page if user manually visited the unsupported page
    isBrowserSupported() ? next({ name: 'Error' }) : next();
  } else {
    if (isBrowserSupported()) {
      next();
    } else {
      // log browser unsupported event even before lesson start
      const consolebizTransport = new bizTransport(store.getters.logTransportToken);
      logger.add(consolebizTransport);
      logger.debug('Browser is unsupported', { operation: 'browser:support' });
      logger.remove(consolebizTransport);
      next({ path: `${to.params.lessonId}/unsupported` });
    }
  }
};

export {
  verifyTestLessonToken,
  verifyAdminTrainerLessonToken,
  verifyLessonToken,
  verifyAccessToMaterial,
  verifyAccessToTrainerMaterial
};
